import gql from 'graphql-tag';
import automaticMailSendFragment from '../automaticMailSend';
import automaticMailFragment from '../automaticMail';

export default gql`
  fragment automaticMailClickProspectActivityFragment on AutomaticMailClickProspectActivity {
    id
    url
    automaticMailSend {
      ...automaticMailSendFragment
      automaticMail {
        ...automaticMailFragment
        stepAutomaticMail {
          step {
            name
          }
        }
      }
    }
  }
  ${automaticMailSendFragment}
  ${automaticMailFragment}
`;
